import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { handleApiError } from "../Helper/actionHelper";

import {
  DAV_DATA_FAILED,
  DAV_DATA_LOADING,
  DAV_DATA_SUCCESS,
  SENT_LINK_FAILED,
  SENT_LINK_LOADING,
  SENT_LINK_SUCCESS,
  CHECK_STATUS_FAILED,
  CHECK_STATUS_LOADING,
  CHECK_STATUS_SUCCESS,
  SAVE_DAV_LOADING,
  SAVE_DAV_SUCCESS,
  SAVE_DAV_FAILED
} from "../Constants/DAVConstants";

const errorMsg = "Something went wrong. Please try again.";

const handleApiMessages = (status, msg) => {
  if (status == 'success' && msg) {
    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } else if (status == 'error') {
    toast.error(msg || errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
}

export const getDAVData = (payloadForQr, checkStatus) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: DAV_DATA_LOADING });
    let requestData = {
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/getDavConfig",
      requestData,
      {
        headers: headers,
      }
    );
    handleApiMessages(data?.status, data?.message || data?.msg);
    const check_id = data?.data?.check_id
    if (data?.data?.dav_checks?.length) {
      const qrRequestData = {
        ...requestData,
        ...payloadForQr,
        check_id : check_id,
      }
      const { data } = await axios.post(FOLDERPATH +
        "/CandidateApi/getDavQrForm",
        qrRequestData,
        {
          headers: headers,
        }
      );
      console.log("data,,,,....", data)
      handleApiMessages(data?.status, data?.message || data?.msg);
      dispatch({
        type: DAV_DATA_SUCCESS,
        payload: data,
      });
      if(checkStatus && data?.status?.toUpperCase() === 'SUCCESS') {
        await dispatch(getDAVStatus());
      }
    }
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: DAV_DATA_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('INSUFF_ERROR..', error)

    handleApiError(error);
  }
};


export const SendLinkData = () => async (dispatch) => {

  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: SENT_LINK_LOADING });
    let requestData = {
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/SendDavLinkToCandidate",
      requestData,
      {
        headers: headers,
      }
    );
    console.log('sentLink Data', data);
    handleApiMessages(data?.status, data?.message || data?.msg);
    dispatch({
      type: SENT_LINK_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: SENT_LINK_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('SENT_LINK_ERROR..', error)

    handleApiError(error);
  }

}

export const getDAVStatus = (obj) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: CHECK_STATUS_LOADING });
    let requestData = {
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/checkDavStatus",
      requestData,
      {
        headers: headers,
      }
    )
    if(data?.status?.toUpperCase() == 'OK') {
      const message = data?.check_status?.toUpperCase() == 'COMPLETED' 
      ? 'DAV Journey has been completed successfully!'
      : 'DAV Journey has not been completed'
      const status = data?.check_status?.toUpperCase() == 'COMPLETED'
      ? 'success'
      : 'error'
      if(obj?.showStatus){
        handleApiMessages( status, message);
      }
      if(obj?.saveDAV){
        dispatch(SaveDAVData())
      }
    } else {
      handleApiMessages(data?.status , data?.message || data?.msg);
    } 
    dispatch({
      type: CHECK_STATUS_SUCCESS,
      payload: data,
    });
    console.log('check status Data', data)

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: CHECK_STATUS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('CHECK_STATUS_ERROR..', error)

    handleApiError(error);
  }
};

export const SaveDAVData = () => async (dispatch) => {

  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: SAVE_DAV_LOADING });
    let requestData = {
      token: userLocalData.id,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH +
      "/CandidateApi/saveDavOverIbridge",
      requestData,
      {
        headers: headers,
      }
    );
    // console.log(' save DAV Data', data);
    if(data?.status == 'error'){
      handleApiMessages(data?.status, data?.message || data?.msg);
    }
    dispatch({
      type: SAVE_DAV_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: SAVE_DAV_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    console.log('SAVE_DAV_ERROR..', error)
    handleApiError(error);
  }
}